import { InboxOutlined } from '@ant-design/icons';
import { TaskCardKanbanStatusPill, TaskCardKanbanStatusDot } from '@/pages/inside/tenant/style';

/**
 * Inline “Backlog Task” callout (matches sprint kanban card + PMO/QA surfaces).
 * Use when `isTaskOnDevBacklog(task)` from projectHelpers.
 */
export function BacklogTaskBanner({ style }) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                ...style,
            }}
            role="status"
        >
            <InboxOutlined
                style={{
                    fontSize: 15,
                    color: 'var(--ant-color-warning, #d48806)',
                    flexShrink: 0,
                }}
                aria-hidden
            />
            <TaskCardKanbanStatusPill $variant="backlog" style={{ marginBottom: 0 }}>
                <TaskCardKanbanStatusDot $variant="backlog" aria-hidden />
                Backlog Task
            </TaskCardKanbanStatusPill>
        </div>
    );
}
